var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNativeApps({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#E7E9EF",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.188 10.5c0-.957.765-1.75 1.75-1.75h6.124c.957 0 1.75.793 1.75 1.75V21c0 .984-.793 1.75-1.75 1.75h-6.125c-.984 0-1.75-.766-1.75-1.75V10.5zM16.875 21a.9.9 0 0 0-.875-.875.881.881 0 0 0-.875.875c0 .492.383.875.875.875a.881.881 0 0 0 .875-.875zm2.188-10.5h-6.125v8.75h6.124V10.5z",
    fill: "#233145"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNativeApps);
export default __webpack_public_path__ + "static/media/native_apps.dcfcd979417f6b8525f23bc8c15a5a9a.svg";
export { ForwardRef as ReactComponent };